import React, { useContext, useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import { Fragment } from "react";
import { Breadcrumb } from "react-bootstrap";
import { AppContext } from "../context/AppContext";
import { Seat } from "@phosphor-icons/react";
import * as Md from "react-icons/md";
import * as Io from "react-icons/io";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { PulseLoader } from "react-spinners";
import { Switch } from "antd";
import Masonry from "react-layout-masonry";

import moment from "moment-timezone";

function CreatePromotions() {
  const { newPromotions, getPromotions, promotionLoading } =
    useContext(AppContext);
  const navigate = useNavigate();
  const [inputValue, setInputValue] = useState("");
  const [values, setValues] = useState([]);
  const [doorDelivery, setDoorDelivery] = useState(false);
  const [file, setFile] = useState(null);
  const [filePreview, setFilePreview] = useState(null);
  const [webFile, setWebFile] = useState(null);
  const [webFilePreview, setWebFilePreview] = useState(null);
  const [paymentType, setPaymentType] = useState("fixedPrice");
  const [currentLocation, setCurrentLocation] = useState("");
  const [takeaway, setTakeaway] = useState(false);
  const [web, setWeb] = useState(true);
  const [mobile, setMobile] = useState(true);
  const [fileDropped, setFileDropped] = useState(false);
  const [webFileDropped, setWebFileDropped] = useState(false);
  const [wPosition, setWPosition] = useState("");
  const [mPosition, setMPosition] = useState("");
  const [error, setError] = useState(false);
  const [offer, setOffer] = useState({
    title: "",
    description: "",
    price: 0,
    discount_price: 0,
    startDate: "",
    endDate: "",
    locations: [],
    products: null,
    offerCode: "",
    usage_count: 0,
    promotionFor: "",
    redirectWebLink: "",
  });
  const token = window.localStorage.getItem("UserRetention");

  const handleOfferInput = (e) => {
    const { name, value } = e.target;

    const numbRegex = /^[0-9\b]+$/;

    if (
      name === "price" ||
      name === "discount_price" ||
      name === "usage_count"
    ) {
      if (value === "" || numbRegex.test(value)) {
        setOffer((prev) => ({
          ...prev,
          [name]: value === "" ? 0 : parseInt(value, 10),
        }));
      }
    } else {
      setOffer((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const isBookingValid = () => {
    const now = moment().tz("Europe/London");
    console.log(now, "now");

    const bookingStartDate = moment(offer?.startDate).tz("Europe/London");
    const bookingEndDate = moment(offer?.endDate).tz("Europe/London");

    if (!bookingStartDate.isValid() || !bookingEndDate.isValid()) {
      console.error("Invalid date format:", offer?.startDate, offer?.endDate);
      return false;
    }

    if (bookingStartDate.isBefore(now) || bookingEndDate.isBefore(now)) {
      return false;
    }
    if (bookingEndDate.isBefore(bookingStartDate)) {
      return false;
    }

    return true;
  };
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      const previewUrl = URL.createObjectURL(selectedFile);
      setFilePreview(previewUrl);
      setFileDropped(true);
    }
  };

  const handleWebFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setWebFile(selectedFile);
      const previewUrl = URL.createObjectURL(selectedFile);
      setWebFilePreview(previewUrl);
      setWebFileDropped(true);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const selectedFile = e.dataTransfer.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      const previewUrl = URL.createObjectURL(selectedFile);
      setFilePreview(previewUrl);
      setFileDropped(true);
    }
  };

  const handleClick = () => {
    document.querySelector(".drop-zone__input_mobile").click();
  };

  const handleWebFileClick = () => {
    document.querySelector(".drop-zone__input").click();
  };
  const handleAddLocation = () => {
    if (currentLocation.trim() !== "") {
      setOffer((prevOffer) => ({
        ...prevOffer,
        locations: [...prevOffer.locations, currentLocation.trim()],
      }));
      setCurrentLocation("");
    }
  };

  const handleLocationInputChange = (e) => {
    const value = e.target.value;
    setCurrentLocation(e.target.value);
  };

  const handleRemoveLocation = (index) => {
    const updatedLocations = offer.locations.filter((_, i) => i !== index);
    setOffer((prevOffer) => ({
      ...prevOffer,
      locations: updatedLocations,
    }));
  };
  const handlePaymentInputChange = (e) => {
    setPaymentType(e.target.value);
  };

  const handleDoorDeliveryChange = (e) => {
    setDoorDelivery(!doorDelivery);
  };
  const handleTakeaway = () => {
    setTakeaway(!takeaway);
  };
  const handleWebsize = () => {
    setWeb(!web);
  };
  const handleMobilesize = () => {
    setMobile(!mobile);
  };
  const handleValidation = () => {
    if (
      offer?.title == 0 ||
      offer?.description == 0 ||
      offer?.startDate == 0 ||
      offer?.endDate == 0 ||
      offer.promotionFor.length == 0
    ) {
      setError(true);
      return true;
    }
    return false;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    const isValid = handleValidation();
    if (isValid == true) return;
    const isValidBookingTime = isBookingValid();

    if (isValidBookingTime === false) {
      toast.error("Please select a valid start and end time!");
      return;
    }

    if (web === true && wPosition.length == 0) {
      toast.error("Please choose the position of the image for the website!");
      return;
    }

    if (mobile === true && mPosition.length == 0) {
      toast.error("Please choose the position of the image for Mobile app!");
      return;
    }

    if (!web && !mobile) {
      toast.error("Please choose Web or Mobile before create a promotion!");
      return;
    }

    const formData = new FormData();

    formData.append("title", offer?.title);
    formData.append("description", offer?.description);
    formData.append("paymentType", paymentType);
    formData.append("price", offer?.price);
    formData.append("discount_price", offer?.discount_price);
    formData.append("startDate", offer?.startDate);
    formData.append("endDate", offer?.endDate);
    formData.append("locations", offer?.locations);
    formData.append("doorDelivery", doorDelivery);
    formData.append("takeAway", takeaway);
    formData.append("products", offer?.products);

    formData.append("offerCode", offer?.offerCode.toUpperCase());
    formData.append("web", web);
    formData.append("mobile", mobile);
    formData.append("wPosition", wPosition);
    formData.append("mPosition", mPosition);
    formData.append("usage_count", offer?.usage_count);
    formData.append("promotionFor", offer?.promotionFor);

    if (offer?.promotionFor == "other" && offer?.redirectWebLink == "") {
      toast.error(
        "Redirections link is required when the promotion for others!"
      );
      window.location.hash = "redirect";
      return;
    }

    formData.append("redirectWebLink", offer.redirectWebLink);

    if (file != null) {
      formData.append("file", file);
    }
    if (webFile != null) {
      formData.append("wFile", webFile);
    }

    // for (var pair of formData.entries()) {
    //   console.log(pair[0] + ", " + pair[1]);
    // }

    // return;

    if (!token) {
      toast.error("Authentication Failed, Please login again!");
      return;
    }

    await newPromotions(formData, {
      onSuccess: async (res) => {
        toast.success("New Promotion is created successfully");
        navigate("/promotion-list");
        await getPromotions(token);
      },
      onFailed: (err) => {
        toast.error(err?.message);
        console.log(err, "error");
      },
    });
  };

  return (
    <>
      <MasterLayout>
        <Fragment>
          <div className="container w-80 mx-auto">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12">
                <h6 className="my-4">Create Promotion</h6>
              </div>
            </div>
            <div className="card p-5">
              <div className="row justify-content-center">
                <div className="col-md-12">
                  <form action="" onSubmit={handleSubmit}>
                    <div className="d-flex justify-content-between align-items-center mb-4"></div>
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Offer Title</label>
                        <input
                          type="text"
                          className="form-control"
                          name="title"
                          value={offer.title}
                          onChange={handleOfferInput}
                        />
                        {error && offer?.title == 0 && (
                          <p className="err__msg">Title is required!</p>
                        )}
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="form-label">Offer Code</label>
                        <input
                          type="text"
                          className="form-control text-uppercase"
                          name="offerCode"
                          value={offer.offerCode}
                          onChange={handleOfferInput}
                        />
                        {error && offer.offerCode == 0 && (
                          <p className="err__msg">Offercode is required!</p>
                        )}
                      </div>
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Offer Description</label>
                      <textarea
                        className="form-control"
                        name="description"
                        value={offer.description}
                        onChange={handleOfferInput}
                      />
                      {error && offer.description == 0 && (
                        <p className="err__msg">Description is required!</p>
                      )}
                    </div>

                    <div className="mb-3">
                      <p className="mb-0 form-label">Payment Type</p>
                      <div className="d-flex">
                        <div className="mx-2 mt-2">
                          <label className="form-label cursor-pointer">
                            <input
                              type="radio"
                              className="form-check-input mb-0 mx-2"
                              value="fixedPrice"
                              checked={paymentType === "fixedPrice"}
                              onChange={handlePaymentInputChange}
                            />
                            Fixed Price
                          </label>
                        </div>
                        <div className="mx-3 mt-2">
                          <label className="form-label cursor-pointer">
                            <input
                              type="radio"
                              className="form-check-input mb-0 mx-2"
                              value="DiscountAmt"
                              checked={paymentType === "DiscountAmt"}
                              onChange={handlePaymentInputChange}
                            />
                            Discount Percentage
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6 col-lg-6 col-sm-12">
                        <div className="row">
                          <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="mb-3">
                              <label className="form-label">
                                Original Price
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                name="price"
                                value={offer.price}
                                onChange={handleOfferInput}
                              />
                              {error && offer.price == 0 && (
                                <p className="err__msg">Price is required!</p>
                              )}
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-6 col-sm-12">
                            <div className="mb-3">
                              <label className="form-label">
                                Discounted Price
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                name="discount_price"
                                value={offer.discount_price}
                                onChange={handleOfferInput}
                              />
                              {error && offer.discount_price == 0 && (
                                <p className="err__msg">
                                  Discount is required!
                                </p>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 col-lg-6 ">
                        <div className="row">
                          <div className="col-lg-6 col-md-6 col-sm-12">
                            <label className="form-label">Start Date</label>
                            <input
                              type="datetime-local"
                              className="form-control"
                              name="startDate"
                              value={offer.startDate}
                              onChange={handleOfferInput}
                            ></input>
                            {error && offer.startDate == 0 && (
                              <p className="err__msg">
                                Start date is required!
                              </p>
                            )}
                          </div>
                          <div className="col-lg-6 col-md-6 col-sm-12">
                            <label className="form-label">End Date</label>
                            <input
                              type="datetime-local"
                              className="form-control"
                              name="endDate"
                              value={offer.endDate}
                              onChange={handleOfferInput}
                            ></input>
                            {error && offer.endDate == 0 && (
                              <p className="err__msg">End date is required!</p>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="mb-4">
                      <div className="row">
                        <div className="col-md-6 mb-3"></div>
                        <div className="col-md-6 mb-3"></div>
                      </div>
                    </div>
                    <div className="row ">
                      <div className="col-md-6 mb-3">
                        <div className="location__">
                          <label className="form-label ">Location</label>

                          <div className="mb-3">
                            <div className="location-in">
                              <input
                                type="text"
                                className="form-control"
                                value={currentLocation}
                                onChange={handleLocationInputChange}
                              />
                              <button
                                onClick={handleAddLocation}
                                type="button"
                                className="add-btn px-3 mx-4 my-2"
                              >
                                <i>
                                  <Io.IoMdAdd />
                                </i>
                              </button>
                            </div>
                            <div>
                              <ul>
                                {offer.locations.map((loc, index) => (
                                  <div className="location_id" key={index}>
                                    <li>{loc}</li>
                                    <button
                                      type="button"
                                      className="remove-btn"
                                      onClick={() =>
                                        handleRemoveLocation(index)
                                      }
                                    >
                                      <Md.MdDelete />
                                    </button>
                                  </div>
                                ))}
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-3 mb-3">
                        <p className="mb-0 form-label mt-3">Door Delivery</p>
                        <div className="d-flex">
                          <div className="mx-2">
                            <label className="form-label cursor-pointer">
                              <input
                                type="radio"
                                className="form-check-input mb-0 mx-2"
                                value="true"
                                checked={!doorDelivery}
                                onChange={handleDoorDeliveryChange}
                              />
                              Yes
                            </label>
                          </div>
                          <div className="mx-3">
                            <label className="form-label cursor-pointer">
                              <input
                                type="radio"
                                className="form-check-input mb-0 mx-2"
                                value="false"
                                checked={doorDelivery}
                                onChange={handleDoorDeliveryChange}
                              />
                              No
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-3 mb-3">
                        <p className="mb-0 form-label mt-3">Takeaway</p>
                        <div className="d-flex">
                          <div className="mx-2">
                            <label className="form-label cursor-pointer">
                              <input
                                type="radio"
                                className="form-check-input mb-0 mx-2"
                                value="true"
                                checked={takeaway}
                                onChange={handleTakeaway}
                              />
                              Yes
                            </label>
                          </div>
                          <div className="mx-3">
                            <label className="form-label cursor-pointer">
                              <input
                                type="radio"
                                className="form-check-input mb-0 mx-2"
                                value="false"
                                checked={!takeaway}
                                onChange={handleTakeaway}
                              />
                              No
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="form-group">
                          <label htmlFor="" className="form-label">
                            Promotion For <span className="text-danger">*</span>
                          </label>
                          <select
                            name=""
                            id=""
                            className="form-select"
                            onChange={(e) =>
                              setOffer((prev) => ({
                                ...prev,
                                promotionFor: e.target.value,
                              }))
                            }
                          >
                            <option value="" disabled selected>
                              select this promotion what for
                            </option>
                            <option value="order-online">Order Online</option>
                            <option value="table-reservation">
                              Table Reservation
                            </option>
                            <option value="other">other</option>
                          </select>
                          {error && offer.promotionFor.length == 0 && (
                            <p className="err__msg">
                              The reason for the promotion is required!
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-12">
                        {offer?.promotionFor == "other" && (
                          <div className="form-group">
                            <label htmlFor="" className="form-label">
                              Web Redirection Link
                            </label>
                            <input
                              type="text"
                              name=""
                              id=""
                              className="form-control"
                              onChange={(e) =>
                                setOffer((prev) => ({
                                  ...prev,
                                  redirectWebLink: e.target.value,
                                }))
                              }
                            />
                          </div>
                        )}
                      </div>
                    </div>
                    <br />
                    <Masonry
                      columns={{ 640: 1, 768: 2, 991: 2, 1024: 2, 1280: 2 }}
                      gap={16}
                    >
                      <div className="">
                        <label htmlFor="device" className="form-label">
                          Web
                          <Switch
                            defaultValue={web}
                            onChange={() => setWeb(!web)}
                            id="device"
                            className="mx-3"
                          />{" "}
                        </label>

                        <p className="mb-0 form-label mt-4">
                          Position type for Web
                        </p>
                        <select
                          className="form-select form-select-sm w-100 bg-base border text-secondary-light"
                          value={wPosition}
                          onChange={(e) => setWPosition(e.target.value)}
                          disabled={!web}
                        >
                          <option value="" selected disabled>
                            Select
                          </option>
                          <option value="banner">Banner</option>
                          <option value="slider">Slider</option>
                          {/* <option value="poster">Poster</option> */}
                        </select>
                        <br />
                        <div className="mb-5 position-relative">
                          <h6>Add an image for your offer</h6>
                          <span>
                            Your Image will be appears on your Web. For best
                            results, use a 4:3 aspect ratio.
                          </span>
                          {!webFileDropped && (
                            <div
                              className={
                                web === false
                                  ? "drop-zone disabled"
                                  : "drop-zone"
                              }
                              onClick={handleWebFileClick}
                            >
                              <span className="drop-zone__prompt_web ">
                                Click to upload
                              </span>
                              <input
                                type="file"
                                name="file"
                                className="drop-zone__input"
                                onChange={handleWebFileChange}
                                style={{ display: "none" }}
                                disabled={!web}
                              />
                            </div>
                          )}

                          {webFile && webFilePreview && (
                            <>
                              <button
                                type="button"
                                className="clear_img"
                                onClick={() => {
                                  setWebFile(null);
                                  setWebFilePreview(null);
                                  setWebFileDropped(false);
                                }}
                              >
                                Clear Image
                              </button>
                              <p>Selected file:</p>
                              <img
                                src={webFilePreview}
                                alt="preview_image"
                                srcset=""
                                className="preview_image mobile"
                              />
                            </>
                          )}
                        </div>
                      </div>

                      <div className="">
                        <label htmlFor="device" className="form-label">
                          Mobile
                          <Switch
                            defaultValue={mobile}
                            onChange={() => setMobile(!mobile)}
                            id="device"
                            className="mx-3"
                          />{" "}
                        </label>

                        <p className="mb-0 form-label mt-4">
                          Position type for Mobile
                        </p>
                        <select
                          className="form-select form-select-sm w-100 bg-base border text-secondary-light"
                          value={mPosition}
                          onChange={(e) => setMPosition(e.target.value)}
                          disabled={!mobile}
                        >
                          <option value="" selected disabled>
                            Select
                          </option>
                          <option value="banner">Banner</option>
                          <option value="slider">Slider</option>
                          <option value="poster">Poster</option>
                        </select>
                        <br />
                        <div className="mb-5 position-relative">
                          <h6>Add an image for your offer</h6>
                          <span>
                            Your Image will be appears on your Mobile. For best
                            results, use a 4:3 aspect ratio.
                          </span>
                          {!fileDropped && (
                            <div
                              className={
                                mobile ? "drop-zone" : "drop-zone disabled"
                              }
                              onClick={handleClick}
                            >
                              <span className="drop-zone__prompt">
                                Click to upload
                              </span>
                              <input
                                type="file"
                                name="file"
                                className="drop-zone__input_mobile"
                                onChange={handleFileChange}
                                style={{ display: "none" }}
                                disabled={!mobile}
                              />
                            </div>
                          )}

                          {file && filePreview && (
                            <>
                              <button
                                type="button"
                                className="clear_img"
                                onClick={() => {
                                  setFile(null);
                                  setFilePreview(null);
                                  setFileDropped(false);
                                }}
                              >
                                Clear Image
                              </button>
                              <p>Selected file:</p>
                              <img
                                src={filePreview}
                                alt="preview_image"
                                srcset=""
                                className="preview_image web"
                              />
                            </>
                          )}
                        </div>
                      </div>
                    </Masonry>

                    <button
                      type="submit"
                      className="btn add_btn mt-3"
                      id="add_prom"
                      disabled={promotionLoading}
                    >
                      {promotionLoading ? (
                        <PulseLoader color="#fff" size={10} />
                      ) : (
                        "Save Offer"
                      )}
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </Fragment>
      </MasterLayout>
    </>
  );
}

export default CreatePromotions;
